export enum TransportManagementEndpoint {
  Base = '/transport-management',
  Loads = '/loads',
  TransportOrders = '/tos',
  Filters = '/filters',
  Exports = '/exports',
  Search = '/search',
  InboundPlants = '/inbound-plants',
  Plants = '/plants',
  Gates = '/gates',
}
